import React from 'react'
import PostForm from './PostForm'

const PostAdd = () => {

  return (
    <>
      <h1>post add</h1>
      <PostForm />
    </>
  )
}

export default PostAdd
